// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import Enums from '../Enums';

export class PriceEscalationQuoteSummary {
  readonly id: string;
  readonly quoteId: string;
  readonly quoteNumber: string;
  readonly projectId: string;
  readonly projectName: string;
  readonly companyId: string | null;
  readonly companyName: string | null;
  readonly statusId: string;
  readonly statusName: string;
  readonly salesRepId: string;
  readonly salesRepName: string;
  readonly escalationDate: DateTime;
  readonly escalationKind: Enums.EscalationKind;
  readonly escalationChangeRatio: string | null;
  readonly escalationFlatChangeAmount: Currency | null;
  readonly appliedBy: string | null;
  readonly appliedAt: string | null;
  readonly isProcessed: boolean;
  readonly currencyCode: Enums.CurrencyCode;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.quoteId = data.quoteId === undefined ? NIL_UUID : data.quoteId;
    this.quoteNumber = data.quoteNumber === undefined ? '' : data.quoteNumber;
    this.projectId = data.projectId === undefined ? NIL_UUID : data.projectId;
    this.projectName = data.projectName === undefined ? '' : data.projectName;
    this.companyId = data.companyId === undefined ? null : data.companyId;
    this.companyName = data.companyName === undefined ? null : data.companyName;
    this.statusId = data.statusId === undefined ? NIL_UUID : data.statusId;
    this.statusName = data.statusName === undefined ? '' : data.statusName;
    this.salesRepId = data.salesRepId === undefined ? NIL_UUID : data.salesRepId;
    this.salesRepName = data.salesRepName === undefined ? '' : data.salesRepName;
    this.escalationDate = DateHelpers.ParseServerDate(data.escalationDate);
    this.escalationKind =
      data.escalationKind === undefined ? Enums.EscalationKind.Percentage : data.escalationKind;
    this.escalationChangeRatio =
      data.escalationChangeRatio === undefined ? null : data.escalationChangeRatio;
    this.escalationFlatChangeAmount =
      (data.escalationFlatChangeAmount ?? null) === null
        ? null
        : NewCurrency(data.escalationFlatChangeAmount);
    this.appliedBy = data.appliedBy === undefined ? null : data.appliedBy;
    this.appliedAt = data.appliedAt === undefined ? null : data.appliedAt;
    this.isProcessed = data.isProcessed === undefined ? false : data.isProcessed;
    this.currencyCode =
      data.currencyCode === undefined ? Enums.CurrencyCode.USD : data.currencyCode;
  }

  static zero(): PriceEscalationQuoteSummary {
    const zeroValues: ExcludeMethodsDeep<PriceEscalationQuoteSummary> = {
      id: NIL_UUID,
      quoteId: NIL_UUID,
      quoteNumber: '',
      projectId: NIL_UUID,
      projectName: '',
      companyId: null,
      companyName: null,
      statusId: NIL_UUID,
      statusName: '',
      salesRepId: NIL_UUID,
      salesRepName: '',
      escalationDate: DateHelpers.ParseServerDate(DateHelpers.ZERO_DATE_STRING),
      escalationKind: Enums.EscalationKind.Percentage,
      escalationChangeRatio: null,
      escalationFlatChangeAmount: null,
      appliedBy: null,
      appliedAt: null,
      isProcessed: false,
      currencyCode: Enums.CurrencyCode.USD,
    };
    return new PriceEscalationQuoteSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PriceEscalationQuoteSummaryWireFormat = {
  id: string;
  quoteId: string;
  quoteNumber: string;
  projectId: string;
  projectName: string;
  companyId: string | null;
  companyName: string | null;
  statusId: string;
  statusName: string;
  salesRepId: string;
  salesRepName: string;
  escalationDate: string;
  escalationKind: string;
  escalationChangeRatio: string | null;
  escalationFlatChangeAmount: CurrencyWireFormat | null;
  appliedBy: string | null;
  appliedAt: string | null;
  isProcessed: boolean;
  currencyCode: string;
};

type NewPriceEscalationQuoteSummaryProps = PartialDeep<
  PriceEscalationQuoteSummary,
  { recurseIntoArrays: true }
>;
export const NewPriceEscalationQuoteSummary: (
  props: NewPriceEscalationQuoteSummaryProps,
) => PriceEscalationQuoteSummary = (props) => new PriceEscalationQuoteSummary(props);

type NewPriceEscalationQuoteSummaryFromWireFormatProps = PartialDeep<
  PriceEscalationQuoteSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPriceEscalationQuoteSummaryFromWireFormat: (
  props: NewPriceEscalationQuoteSummaryFromWireFormatProps,
) => PriceEscalationQuoteSummary = (props) => new PriceEscalationQuoteSummary(props);
